/**
 * Created by mariushirjanu on 03/09/2019.
 */
import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { IEditableTextOption } from '../editable-text/editable-text.service';
import { GaStateService } from '../services/ga-state.service';
import * as _ from 'underscore';

/**
 * @ngdoc component
 * @name ga2.shared.text:text
 *
 * @description A directive for displaying a text that can be edited. The translation depends of the screen where the directive is loaded
 *
 * Eg.:
 *  <text name='KEY'></text>
 *  <h2><text name='HEADING'></text></h2>
 *  <text text='SELECT_PROFILE' screen="BPPROFILES"></text>
 *
 * @param {screen} Screen of the translation text
 */

interface ITextDirectiveBindings {
  key:string;
  screen?:string;
  heading?:boolean;
}

const HEADING_ELEMENTS:string[] = ['h1','h2','h3','h4','h5','h6'];

@Component({
  selector: 'text',
  template: `
    <editable-text [key]="key" [screen]="screen" [menu]="menu" highlight=">div" (onModeChange)="onModeChange($event)" [customMenu]="customMenu"></editable-text>
    <div *ngIf="!editMode" [innerHTML]="translationKey | translateDefault: \'\'"></div>
    <div *ngIf="editMode" [innerHTML]="translationKey | translate"></div>
  `
})
export class TextComponent implements OnInit, ITextDirectiveBindings {
  @Input() public screen:string;
  @Input() public key:string;
  @Input() public customMenu:IEditableTextOption[];

  public translationKey:string;
  public menu:string;
  public editMode:boolean;

  constructor(
    private stateService:GaStateService,
    private elementRef:ElementRef<HTMLElement>
  ) {/***/
  }

  public ngOnInit():void {
    this.screen = this.screen || this.stateService.screen;
    this.menu = this.isHeading? 'title' : 'text';
    this.translationKey = `${this.screen}.${this.key}.${this.menu}`.toUpperCase(); // compose the translation key;
  }

  private get isHeading():boolean {
    return this.key === 'HEADING' || !!_.find(HEADING_ELEMENTS, (value:string) => value === this.elementRef?.nativeElement?.parentElement?.localName);
  }

  public onModeChange(editMode:boolean):void {
    this.editMode = editMode;
  }
}